import { useQuery } from "react-query";

import { autoChecklistService } from "services";

const useJarisCheckListQuery = ({ id }: { id: string }) =>
	useQuery(
		["jarisCheckList", id],
		() => autoChecklistService.getJarisCheckList(id),
		{
			retry: 0,
			cacheTime: 3000,
			staleTime: 3000,
			enabled: !!id,
		},
	);

export default useJarisCheckListQuery;
